import { createApp } from 'vue';
import JobsearchNewJobsearchSwitch from 'JIX/components/jobsearch/JobsearchNewJobsearchSwitch.vue';

const newJobsearchSwitchMobileContainer = document.getElementById('new-jobsearch-switch-mobile');
if (newJobsearchSwitchMobileContainer) {
    createApp(JobsearchNewJobsearchSwitch).mount(newJobsearchSwitchMobileContainer);
}